import { render } from "./empty-placeholder.vue?vue&type=template&id=66ce0bfc&scoped=true&ts=true"
import script from "./empty-placeholder.vue?vue&type=script&lang=ts"
export * from "./empty-placeholder.vue?vue&type=script&lang=ts"

import "./empty-placeholder.vue?vue&type=style&index=0&id=66ce0bfc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66ce0bfc"]])

export default __exports__